import React from "react";
import { replaceImgWithAmpImg } from "../lib/image";
import "./HtmlEmbed.style.scss";

export interface HtmlProps {
    html: string;
    schedule: {};
    amp?: boolean;
}

export const HtmlEmbedLegacy = ({ html: __html, amp }: HtmlProps) => {
    if (amp && __html.includes("<img")) {
        __html = replaceImgWithAmpImg(__html);
    }
    return <div className="component-embed-html" dangerouslySetInnerHTML={{ __html }} />;
};

export default HtmlEmbedLegacy;
